import { Link } from "react-router-dom";
import { Search, Megaphone, KanbanSquare } from "lucide-react";
import { Section } from "@/components/ui-brand";

const BENEFICIOS = [
  { icon: Search, t: "Encontrá talento formado", d: "Buscá perfiles de egresados/as de Córdoba Crea Futuro por formación, habilidades y ubicación, o describí lo que necesitás y la IA lo traduce a filtros." },
  { icon: Megaphone, t: "Publicá tus búsquedas", d: "Cargá una búsqueda laboral en minutos y recibí postulaciones de personas con la formación que pedís." },
  { icon: KanbanSquare, t: "Gestioná tus postulantes", d: "Seguí a cada postulante en un tablero simple, desde que lo recibís hasta la contratación." },
];

export default function Empresas() {
  return (
    <div data-testid="empresas-landing">
      <section className="hero-grid-bg border-b border-slate-100">
        <Section className="py-14 sm:py-20 max-w-3xl">
          <p className="text-xs font-heading font-bold uppercase tracking-wide text-[var(--brand-accent)]">Para empresas y organizaciones</p>
          <h1 className="h-hero text-3xl sm:text-5xl mt-4">Sumá talento formado en Córdoba</h1>
          <p className="text-base sm:text-lg text-[var(--brand-text-muted)] mt-5 leading-relaxed">
            Conectá con egresados/as de Córdoba Crea Futuro que ya muestran sus fortalezas y están listos/as para su próximo empleo.
          </p>
          <div className="flex flex-wrap gap-3 mt-8">
            <Link to="/registro?tipo=empresa" className="btn-primary" data-testid="empresas-registrar">Registrar mi empresa</Link>
            <Link to="/ingresar" className="btn-outline" data-testid="empresas-ingresar">Ya tengo cuenta</Link>
          </div>
        </Section>
      </section>
      <Section className="py-12 sm:py-16 grid sm:grid-cols-3 gap-6">
        {BENEFICIOS.map(({ icon: Icon, t, d }) => (
          <div key={t} className="card-brand p-6">
            <Icon size={22} className="text-[var(--brand-accent)]" />
            <h2 className="font-heading font-bold text-base sm:text-lg text-[var(--brand-primary)] mt-3">{t}</h2>
            <p className="text-sm text-[var(--brand-text-muted)] mt-2 leading-relaxed">{d}</p>
          </div>
        ))}
      </Section>
    </div>
  );
}
